import React from "react";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import "../common.scss";
import ViewImages from "../viewImages/viewImages";
import "./witnessReport.scss";
import { formatOrNA } from "../../../../utils/helper";

const WitnessRepot = ({ witnessData }) => {
  const imageSize = {
    size: "small",
  };
  return (
    <div className="commonOveride">
      <Box className="commoninfoWrap">
        <Box className="commoninfoBox">
          <Box className="commoninfoleft">
            <Typography className="title">Witness Details:</Typography>
            <div className="witnessBox">
              {witnessData
                ?.sort(
                  (a, b) =>
                    (a?.witnessId || a?.id || 0) - (b?.witnessId || b?.id || 0)
                )
                ?.map((list, i) => {
                  const image = list?.files ? list?.files : "";
                  const witness_image_result = image?.split("|");
                  return (
                    <>
                      <div
                        className="witnessList"
                        key={list?.witnessId || list?.id || i}
                      >
                        <Typography className="listView">
                          Witness Detail {i + 1}:
                        </Typography>
                        <Box className="columns">
                          <Typography className="listView">
                            Name:
                            <span className="font-w400">
                              {list?.witnessName}
                            </span>
                          </Typography>
                          <Typography className="listView">
                            Employer's Name:
                            <span className="font-w400">
                              {formatOrNA(list?.employerName)}
                            </span>
                          </Typography>
                        </Box>
                        <Typography className="listView">
                          Job Title:
                          <span>{formatOrNA(list?.jobTitle)}</span>
                        </Typography>
                        <Typography className="listView">
                          Statement:
                          <span className="blockView textNormal">
                            {formatOrNA(list?.statement)}
                          </span>
                        </Typography>
                        <Typography className="listView desNone">
                          Photos:
                        </Typography>
                        <Typography className="listView desNone">
                          {witness_image_result?.length > 0 &&
                          witness_image_result[0] ? (
                            <ViewImages
                              image={witness_image_result}
                              imageSize={imageSize}
                              showName={false}
                            />
                          ) : (
                            <span className="font-w400">N/A</span>
                          )}
                        </Typography>
                      </div>
                    </>
                  );
                })}
            </div>
          </Box>
          <Box className="commoninfoRight">
            <Box className="commonSignatureBox">
              {/* <p className="title">Signature:</p>
              <div className="box">
                <img src={""} alt="incident-type" />
              </div> */}
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default WitnessRepot;
